import './index.scss'
export default function BaseButton({ disabled, onClick, children, type = '', className = '' }) {
  return (
    <button className={`BaseButton BaseButton_${type} ${className}`} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  )
}
